export const ADMIN_TOKEN_KEY = 'nl_admin_token';
